/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorAIAssistantReception,
  PharmacyCounselorAIAssistantReceptionFromJSON,
  PharmacyCounselorAIAssistantReceptionFromJSONTyped,
  PharmacyCounselorAIAssistantReceptionToJSON,
  PharmacyCounselorBilling,
  PharmacyCounselorBillingFromJSON,
  PharmacyCounselorBillingFromJSONTyped,
  PharmacyCounselorBillingToJSON,
  PharmacyCounselorCounselingPatient,
  PharmacyCounselorCounselingPatientFromJSON,
  PharmacyCounselorCounselingPatientFromJSONTyped,
  PharmacyCounselorCounselingPatientToJSON,
  PharmacyCounselorDelivery,
  PharmacyCounselorDeliveryFromJSON,
  PharmacyCounselorDeliveryFromJSONTyped,
  PharmacyCounselorDeliveryToJSON,
  PharmacyCounselorDispensing,
  PharmacyCounselorDispensingFromJSON,
  PharmacyCounselorDispensingFromJSONTyped,
  PharmacyCounselorDispensingToJSON,
  PharmacyCounselorFollowUp,
  PharmacyCounselorFollowUpFromJSON,
  PharmacyCounselorFollowUpFromJSONTyped,
  PharmacyCounselorFollowUpToJSON,
  PharmacyCounselorIndividualDelivery,
  PharmacyCounselorIndividualDeliveryFromJSON,
  PharmacyCounselorIndividualDeliveryFromJSONTyped,
  PharmacyCounselorIndividualDeliveryToJSON,
  PharmacyCounselorInterview,
  PharmacyCounselorInterviewFromJSON,
  PharmacyCounselorInterviewFromJSONTyped,
  PharmacyCounselorInterviewToJSON,
  PharmacyCounselorMynaHomeWeb,
  PharmacyCounselorMynaHomeWebFromJSON,
  PharmacyCounselorMynaHomeWebFromJSONTyped,
  PharmacyCounselorMynaHomeWebToJSON,
  PharmacyCounselorPersonalHealthRecord,
  PharmacyCounselorPersonalHealthRecordFromJSON,
  PharmacyCounselorPersonalHealthRecordFromJSONTyped,
  PharmacyCounselorPersonalHealthRecordToJSON,
  PharmacyCounselorPharmacist,
  PharmacyCounselorPharmacistFromJSON,
  PharmacyCounselorPharmacistFromJSONTyped,
  PharmacyCounselorPharmacistToJSON,
  PharmacyCounselorPharmacy,
  PharmacyCounselorPharmacyFromJSON,
  PharmacyCounselorPharmacyFromJSONTyped,
  PharmacyCounselorPharmacyToJSON,
  PharmacyCounselorPrescription,
  PharmacyCounselorPrescriptionFromJSON,
  PharmacyCounselorPrescriptionFromJSONTyped,
  PharmacyCounselorPrescriptionToJSON,
  PharmacyCounselorRefill,
  PharmacyCounselorRefillFromJSON,
  PharmacyCounselorRefillFromJSONTyped,
  PharmacyCounselorRefillToJSON,
  PharmacyCounselorServiceNeeds,
  PharmacyCounselorServiceNeedsFromJSON,
  PharmacyCounselorServiceNeedsFromJSONTyped,
  PharmacyCounselorServiceNeedsToJSON,
  PharmacyCounselorTalkroom,
  PharmacyCounselorTalkroomFromJSON,
  PharmacyCounselorTalkroomFromJSONTyped,
  PharmacyCounselorTalkroomToJSON,
  PharmacyCounselorVideoChat,
  PharmacyCounselorVideoChatFromJSON,
  PharmacyCounselorVideoChatFromJSONTyped,
  PharmacyCounselorVideoChatToJSON,
} from "./";

export const PostCounselingResponseTypename = "PostCounselingResponse" as const;

/**
 *
 * @export
 * @interface PostCounselingResponse
 */
export interface PostCounselingResponse {
  /**
   *
   * @type {number}
   * @memberof PostCounselingResponse
   */
  acceptCode?: number;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  acceptReminded?: boolean;
  /**
   *
   * @type {Date}
   * @memberof PostCounselingResponse
   */
  acceptedTime?: string;
  /**
   * AI Assistant counseling ID
   * @type {string}
   * @memberof PostCounselingResponse
   */
  aiAssistantCounselingId?: string;
  /**
   *
   * @type {PharmacyCounselorAIAssistantReception}
   * @memberof PostCounselingResponse
   */
  aiAssistantReception?: PharmacyCounselorAIAssistantReception;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  alarmed?: boolean;
  /**
   *
   * @type {PharmacyCounselorBilling}
   * @memberof PostCounselingResponse
   */
  billing?: PharmacyCounselorBilling;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  canceledByDoctor?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  canceledByPatient?: boolean;
  /**
   *
   * @type {Date}
   * @memberof PostCounselingResponse
   */
  canceledTime?: string;
  /**
   *
   * @type {number}
   * @memberof PostCounselingResponse
   */
  childWeight?: number;
  /**
   *
   * @type {number}
   * @memberof PostCounselingResponse
   */
  clinicCounselingId?: number;
  /**
   *
   * @type {number}
   * @memberof PostCounselingResponse
   */
  clinicId?: number;
  /**
   *
   * @type {Date}
   * @memberof PostCounselingResponse
   */
  completedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  correlationId?: string;
  /**
   * not responded to patient
   * @type {string}
   * @memberof PostCounselingResponse
   */
  counselingNote?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  creditCardId?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  currentSymptoms?: string;
  /**
   *
   * @type {PharmacyCounselorDelivery}
   * @memberof PostCounselingResponse
   */
  delivery: PharmacyCounselorDelivery;
  /**
   *
   * @type {PharmacyCounselorDispensing}
   * @memberof PostCounselingResponse
   */
  dispensing?: PharmacyCounselorDispensing;
  /**
   *
   * @type {PharmacyCounselorFollowUp}
   * @memberof PostCounselingResponse
   */
  followUp?: PharmacyCounselorFollowUp;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  hasMedicineNotebook?: PostCounselingResponseHasMedicineNotebookEnum;
  /**
   *
   * @type {number}
   * @memberof PostCounselingResponse
   */
  id: number;
  /**
   *
   * @type {PharmacyCounselorIndividualDelivery}
   * @memberof PostCounselingResponse
   */
  individualDelivery?: PharmacyCounselorIndividualDelivery;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  insuranceCardType?: PostCounselingResponseInsuranceCardTypeEnum;
  /**
   *
   * @type {PharmacyCounselorInterview}
   * @memberof PostCounselingResponse
   */
  interview?: PharmacyCounselorInterview;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  isAcceptCodeVisible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  isIntegrated?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingResponse
   */
  isPrescriptionSharingAgreed?: boolean;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  managementNo?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PostCounselingResponse
   */
  medicalInformationPaths?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  messageToPatient?: string;
  /**
   *
   * @type {PharmacyCounselorMynaHomeWeb}
   * @memberof PostCounselingResponse
   */
  mynaHomeWeb?: PharmacyCounselorMynaHomeWeb;
  /**
   *
   * @type {object}
   * @memberof PostCounselingResponse
   */
  optionalInformation?: object;
  /**
   * OTC order screening ID (ULID). Set only for online_otc_guidance; null otherwise
   * @type {string}
   * @memberof PostCounselingResponse
   */
  otcOrderScreeningId?: string;
  /**
   *
   * @type {PharmacyCounselorCounselingPatient}
   * @memberof PostCounselingResponse
   */
  patient: PharmacyCounselorCounselingPatient;
  /**
   *
   * @type {PharmacyCounselorPersonalHealthRecord}
   * @memberof PostCounselingResponse
   */
  personalHealthRecord?: PharmacyCounselorPersonalHealthRecord;
  /**
   *
   * @type {PharmacyCounselorPharmacist}
   * @memberof PostCounselingResponse
   */
  pharmacist?: PharmacyCounselorPharmacist;
  /**
   *
   * @type {PharmacyCounselorPharmacy}
   * @memberof PostCounselingResponse
   */
  pharmacy?: PharmacyCounselorPharmacy;
  /**
   *
   * @type {number}
   * @memberof PostCounselingResponse
   */
  pharmacyId: number;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  pharmacyMessageType?: PostCounselingResponsePharmacyMessageTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof PostCounselingResponse
   */
  preferredTimes?: Array<string>;
  /**
   *
   * @type {PharmacyCounselorPrescription}
   * @memberof PostCounselingResponse
   */
  prescription?: PharmacyCounselorPrescription;
  /**
   *
   * @type {Array<string>}
   * @memberof PostCounselingResponse
   */
  prescriptionPaths?: Array<string>;
  /**
   *
   * @type {Date}
   * @memberof PostCounselingResponse
   */
  prescriptionUpdatedTime?: string;
  /**
   * URL for reception slip QR code. ai-assistant-operator role only
   * @type {string}
   * @memberof PostCounselingResponse
   */
  receptionSlipUrl?: string;
  /**
   *
   * @type {PharmacyCounselorRefill}
   * @memberof PostCounselingResponse
   */
  refill?: PharmacyCounselorRefill;
  /**
   * operator role only
   * @type {string}
   * @memberof PostCounselingResponse
   */
  requestToken?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  requestType?: PostCounselingResponseRequestTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof PostCounselingResponse
   */
  requestedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  reserverType?: PostCounselingResponseReserverTypeEnum;
  /**
   *
   * @type {PharmacyCounselorServiceNeeds}
   * @memberof PostCounselingResponse
   */
  serviceNeeds?: PharmacyCounselorServiceNeeds;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  status: PostCounselingResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  statusDetail?: string;
  /**
   *
   * @type {PharmacyCounselorTalkroom}
   * @memberof PostCounselingResponse
   */
  talkroom?: PharmacyCounselorTalkroom;
  /**
   *
   * @type {Date}
   * @memberof PostCounselingResponse
   */
  time?: string;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  type: PostCounselingResponseTypeEnum;
  /**
   *
   * @type {PharmacyCounselorVideoChat}
   * @memberof PostCounselingResponse
   */
  videoChat?: PharmacyCounselorVideoChat;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  waitingLabel?: PostCounselingResponseWaitingLabelEnum;
  /**
   *
   * @type {string}
   * @memberof PostCounselingResponse
   */
  wantsGeneric?: PostCounselingResponseWantsGenericEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostCounselingResponse
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseHasMedicineNotebookEnum {
  None = "none",
  Paper = "paper",
  Digital = "digital",
  Yqb = "yqb",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseInsuranceCardTypeEnum {
  Health = "health",
  Myna = "myna",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponsePharmacyMessageTypeEnum {
  Preferred = "preferred",
  Busy = "busy",
  LongTimeDispensing = "long_time_dispensing",
  DoubtfulItem = "doubtful_item",
  OutOfStock = "out_of_stock",
  Other = "other",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseRequestTypeEnum {
  Web = "web",
  Line = "line",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseReserverTypeEnum {
  Principal = "principal",
  Proxy = "proxy",
  Either = "either",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseStatusEnum {
  Requested = "requested",
  Canceled = "canceled",
  Accepted = "accepted",
  Waiting = "waiting",
  CounselingStarted = "counseling_started",
  CounselingCompleted = "counseling_completed",
  BillingProcessing = "billing_processing",
  BillingCompleted = "billing_completed",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseTypeEnum {
  OnlineCounseling = "online_counseling",
  Dispensing = "dispensing",
  FollowUpOnly = "follow_up_only",
  DeliveryOnly = "delivery_only",
  DirectVisit = "direct_visit",
  AiAssistedReception = "ai_assisted_reception",
  OnlineOtcGuidance = "online_otc_guidance",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseWaitingLabelEnum {
  GoOut = "go_out",
  AfterTomorrow = "after_tomorrow",
  Hurry = "hurry",
  Ambiguous = "ambiguous",
  UrgencyLow = "urgency_low",
  UrgencyMiddle = "urgency_middle",
  UrgencyHigh = "urgency_high",
  HasContact = "has_contact",
} /**
 * @export
 * @enum {string}
 */
export enum PostCounselingResponseWantsGenericEnum {
  None = "none",
  Want = "want",
  Consultation = "consultation",
}

export function PostCounselingResponseFromJSON(json: any): PostCounselingResponse {
  return PostCounselingResponseFromJSONTyped(json, false);
}

export function PostCounselingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostCounselingResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostCounselingResponseTypename,

    acceptCode: !exists(json, "accept_code") ? undefined : json["accept_code"],
    acceptReminded: !exists(json, "accept_reminded") ? undefined : json["accept_reminded"],
    acceptedTime:
      !exists(json, "accepted_time") ||
      (typeof json["accepted_time"] === "string" && json["accepted_time"].substring(0, 4) === "0001")
        ? undefined
        : json["accepted_time"],
    aiAssistantCounselingId: !exists(json, "ai_assistant_counseling_id")
      ? undefined
      : json["ai_assistant_counseling_id"],
    aiAssistantReception: !exists(json, "ai_assistant_reception")
      ? undefined
      : PharmacyCounselorAIAssistantReceptionFromJSON(json["ai_assistant_reception"]),
    alarmed: !exists(json, "alarmed") ? undefined : json["alarmed"],
    billing: !exists(json, "billing") ? undefined : PharmacyCounselorBillingFromJSON(json["billing"]),
    canceledByDoctor: !exists(json, "canceled_by_doctor") ? undefined : json["canceled_by_doctor"],
    canceledByPatient: !exists(json, "canceled_by_patient") ? undefined : json["canceled_by_patient"],
    canceledTime:
      !exists(json, "canceled_time") ||
      (typeof json["canceled_time"] === "string" && json["canceled_time"].substring(0, 4) === "0001")
        ? undefined
        : json["canceled_time"],
    childWeight: !exists(json, "child_weight")
      ? undefined
      : json["child_weight"] == ""
        ? undefined
        : json["child_weight"],
    clinicCounselingId: !exists(json, "clinic_counseling_id") ? undefined : json["clinic_counseling_id"],
    clinicId: !exists(json, "clinic_id") ? undefined : json["clinic_id"],
    completedTime:
      !exists(json, "completed_time") ||
      (typeof json["completed_time"] === "string" && json["completed_time"].substring(0, 4) === "0001")
        ? undefined
        : json["completed_time"],
    correlationId: !exists(json, "correlation_id") ? undefined : json["correlation_id"],
    counselingNote: !exists(json, "counseling_note") ? undefined : json["counseling_note"],
    creditCardId: !exists(json, "credit_card_id") ? undefined : json["credit_card_id"],
    currentSymptoms: !exists(json, "current_symptoms") ? undefined : json["current_symptoms"],
    delivery: PharmacyCounselorDeliveryFromJSON(json["delivery"]),
    dispensing: !exists(json, "dispensing") ? undefined : PharmacyCounselorDispensingFromJSON(json["dispensing"]),
    followUp: !exists(json, "follow_up") ? undefined : PharmacyCounselorFollowUpFromJSON(json["follow_up"]),
    hasMedicineNotebook: !exists(json, "has_medicine_notebook") ? undefined : json["has_medicine_notebook"],
    id: json["id"],
    individualDelivery: !exists(json, "individual_delivery")
      ? undefined
      : PharmacyCounselorIndividualDeliveryFromJSON(json["individual_delivery"]),
    insuranceCardType: !exists(json, "insurance_card_type") ? undefined : json["insurance_card_type"],
    interview: !exists(json, "interview") ? undefined : PharmacyCounselorInterviewFromJSON(json["interview"]),
    isAcceptCodeVisible: !exists(json, "is_accept_code_visible") ? undefined : json["is_accept_code_visible"],
    isIntegrated: !exists(json, "is_integrated") ? undefined : json["is_integrated"],
    isPrescriptionSharingAgreed: !exists(json, "is_prescription_sharing_agreed")
      ? undefined
      : json["is_prescription_sharing_agreed"],
    managementNo: !exists(json, "management_no") ? undefined : json["management_no"],
    medicalInformationPaths: !exists(json, "medical_information_paths") ? undefined : json["medical_information_paths"],
    message: !exists(json, "message") ? undefined : json["message"],
    messageToPatient: !exists(json, "message_to_patient") ? undefined : json["message_to_patient"],
    mynaHomeWeb: !exists(json, "myna_home_web")
      ? undefined
      : PharmacyCounselorMynaHomeWebFromJSON(json["myna_home_web"]),
    optionalInformation: !exists(json, "optional_information") ? undefined : json["optional_information"],
    otcOrderScreeningId: !exists(json, "otc_order_screening_id") ? undefined : json["otc_order_screening_id"],
    patient: PharmacyCounselorCounselingPatientFromJSON(json["patient"]),
    personalHealthRecord: !exists(json, "personal_health_record")
      ? undefined
      : PharmacyCounselorPersonalHealthRecordFromJSON(json["personal_health_record"]),
    pharmacist: !exists(json, "pharmacist") ? undefined : PharmacyCounselorPharmacistFromJSON(json["pharmacist"]),
    pharmacy: !exists(json, "pharmacy") ? undefined : PharmacyCounselorPharmacyFromJSON(json["pharmacy"]),
    pharmacyId: json["pharmacy_id"],
    pharmacyMessageType: !exists(json, "pharmacy_message_type") ? undefined : json["pharmacy_message_type"],
    preferredTimes: !exists(json, "preferred_times") ? undefined : json["preferred_times"],
    prescription: !exists(json, "prescription")
      ? undefined
      : PharmacyCounselorPrescriptionFromJSON(json["prescription"]),
    prescriptionPaths: !exists(json, "prescription_paths") ? undefined : json["prescription_paths"],
    prescriptionUpdatedTime:
      !exists(json, "prescription_updated_time") ||
      (typeof json["prescription_updated_time"] === "string" &&
        json["prescription_updated_time"].substring(0, 4) === "0001")
        ? undefined
        : json["prescription_updated_time"],
    receptionSlipUrl: !exists(json, "reception_slip_url") ? undefined : json["reception_slip_url"],
    refill: !exists(json, "refill") ? undefined : PharmacyCounselorRefillFromJSON(json["refill"]),
    requestToken: !exists(json, "request_token") ? undefined : json["request_token"],
    requestType: !exists(json, "request_type") ? undefined : json["request_type"],
    requestedTime:
      !exists(json, "requested_time") ||
      (typeof json["requested_time"] === "string" && json["requested_time"].substring(0, 4) === "0001")
        ? undefined
        : json["requested_time"],
    reserverType: !exists(json, "reserver_type") ? undefined : json["reserver_type"],
    serviceNeeds: !exists(json, "service_needs")
      ? undefined
      : PharmacyCounselorServiceNeedsFromJSON(json["service_needs"]),
    status: json["status"],
    statusDetail: !exists(json, "status_detail") ? undefined : json["status_detail"],
    talkroom: !exists(json, "talkroom") ? undefined : PharmacyCounselorTalkroomFromJSON(json["talkroom"]),
    time:
      !exists(json, "time") || (typeof json["time"] === "string" && json["time"].substring(0, 4) === "0001")
        ? undefined
        : json["time"],
    type: json["type"],
    videoChat: !exists(json, "video_chat") ? undefined : PharmacyCounselorVideoChatFromJSON(json["video_chat"]),
    waitingLabel: !exists(json, "waiting_label") ? undefined : json["waiting_label"],
    wantsGeneric: !exists(json, "wants_generic") ? undefined : json["wants_generic"],
  };
}

export function PostCounselingResponseToJSON(object?: PostCounselingResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    accept_code: value.acceptCode,
    accept_reminded: value.acceptReminded,
    accepted_time: value.acceptedTime === undefined ? undefined : tzDate(value.acceptedTime).format(),
    ai_assistant_counseling_id: value.aiAssistantCounselingId,
    ai_assistant_reception: PharmacyCounselorAIAssistantReceptionToJSON(value.aiAssistantReception),
    alarmed: value.alarmed,
    billing: PharmacyCounselorBillingToJSON(value.billing),
    canceled_by_doctor: value.canceledByDoctor,
    canceled_by_patient: value.canceledByPatient,
    canceled_time: value.canceledTime === undefined ? undefined : tzDate(value.canceledTime).format(),
    child_weight: (value.childWeight as unknown as string) == "" ? undefined : value.childWeight,
    clinic_counseling_id: value.clinicCounselingId,
    clinic_id: value.clinicId,
    completed_time: value.completedTime === undefined ? undefined : tzDate(value.completedTime).format(),
    correlation_id: value.correlationId,
    counseling_note: value.counselingNote,
    credit_card_id: value.creditCardId,
    current_symptoms: value.currentSymptoms,
    delivery: PharmacyCounselorDeliveryToJSON(value.delivery),
    dispensing: PharmacyCounselorDispensingToJSON(value.dispensing),
    follow_up: PharmacyCounselorFollowUpToJSON(value.followUp),
    has_medicine_notebook: value.hasMedicineNotebook,
    id: value.id,
    individual_delivery: PharmacyCounselorIndividualDeliveryToJSON(value.individualDelivery),
    insurance_card_type: value.insuranceCardType,
    interview: PharmacyCounselorInterviewToJSON(value.interview),
    is_accept_code_visible: value.isAcceptCodeVisible,
    is_integrated: value.isIntegrated,
    is_prescription_sharing_agreed: value.isPrescriptionSharingAgreed,
    management_no: value.managementNo,
    medical_information_paths: value.medicalInformationPaths,
    message: value.message,
    message_to_patient: value.messageToPatient,
    myna_home_web: PharmacyCounselorMynaHomeWebToJSON(value.mynaHomeWeb),
    optional_information: value.optionalInformation,
    otc_order_screening_id: value.otcOrderScreeningId,
    patient: PharmacyCounselorCounselingPatientToJSON(value.patient),
    personal_health_record: PharmacyCounselorPersonalHealthRecordToJSON(value.personalHealthRecord),
    pharmacist: PharmacyCounselorPharmacistToJSON(value.pharmacist),
    pharmacy: PharmacyCounselorPharmacyToJSON(value.pharmacy),
    pharmacy_id: value.pharmacyId,
    pharmacy_message_type: value.pharmacyMessageType,
    preferred_times: value.preferredTimes,
    prescription: PharmacyCounselorPrescriptionToJSON(value.prescription),
    prescription_paths: value.prescriptionPaths,
    prescription_updated_time:
      value.prescriptionUpdatedTime === undefined ? undefined : tzDate(value.prescriptionUpdatedTime).format(),
    reception_slip_url: value.receptionSlipUrl,
    refill: PharmacyCounselorRefillToJSON(value.refill),
    request_token: value.requestToken,
    request_type: value.requestType,
    requested_time: value.requestedTime === undefined ? undefined : tzDate(value.requestedTime).format(),
    reserver_type: value.reserverType,
    service_needs: PharmacyCounselorServiceNeedsToJSON(value.serviceNeeds),
    status: value.status,
    status_detail: value.statusDetail,
    talkroom: PharmacyCounselorTalkroomToJSON(value.talkroom),
    time: value.time === undefined ? undefined : tzDate(value.time).format(),
    type: value.type,
    video_chat: PharmacyCounselorVideoChatToJSON(value.videoChat),
    waiting_label: value.waitingLabel,
    wants_generic: value.wantsGeneric,
  };
}
